var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "wrapper", staticClass: "single-select" }, [
    _c("div", { staticClass: "trigger", on: { click: _vm.toggle } }, [
      _c("span", [_vm._v(_vm._s(_vm.selectedLabel))])
    ]),
    _vm._v(" "),
    _vm.open
      ? _c(
          "div",
          { staticClass: "dropdown" },
          _vm._l(_vm.items, function(item) {
            return _c(
              "div",
              {
                key: item.id,
                staticClass: "option",
                class: { selected: item.id === _vm.value },
                on: {
                  click: function($event) {
                    _vm.select(item)
                  }
                }
              },
              [_vm._v("\n      " + _vm._s(item.text) + "\n    ")]
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c6f8dcd8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6f8dcd8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SingleSelect.vue
// module id = null
// module chunks = 